module.exports = __webpack_public_path__ + "static/media/mask3.ef41e8da.JPG";